/* Contains the core functions for making http calls */
/*
  imports
*/
import { useRouter } from "vue-router";
import { TOTAL_TIME_SLOTS_IN_DIARY, useAppStatus } from "../use/useAppStatus";
import { IDbTimeSlot } from "../interfaces/db-time-slot.interface"
import { IStatusDay } from '../interfaces/status-day.interface';
import { useTouchpointsHTTP, getDays } from '../use/useTouchpointsHTTP';


/*
  router
*/
const router = useRouter();
const { appStatus } = useAppStatus();
const touchPointsComposable: any = useTouchpointsHTTP();


/*
  Check is all Time-Slot complete
*/
async function checkIsAllTimeSlotComplete(){
  const dbTimeSlotsTemp: IDbTimeSlot[] = [];
  const sevenDaysData: IDbTimeSlot[] = [];
  for (let sevenDay = 0; sevenDay < 7; sevenDay++) {
    await touchPointsComposable.getTimeSlotSections(appStatus.userName, sevenDay).then((result:any)=>{
     for (let i = 0; i < result.data.length; i++) {
      dbTimeSlotsTemp.push(result.data[i]);
     }
    }).catch(()=>{
      throw new Error("Time Slots load from DB failed!")
    })
  }

  for (let i = 0; i < dbTimeSlotsTemp.length; i++) {
    if(dbTimeSlotsTemp[i].section_index === 0)
    {
      sevenDaysData.push(dbTimeSlotsTemp[i]);
    }
  }

  //Check if all 7 days timeslot is complete
  let completeCount = 0;
  for (const curIndex in sevenDaysData) {
      if(sevenDaysData[curIndex].status_id === 4 || sevenDaysData[curIndex].status_id === 5){
        completeCount++;
      }
  }
  if(completeCount === TOTAL_TIME_SLOTS_IN_DIARY){
    console.log("useTimeslotComplete all time slot complete ~~~~~~~~~~~~");
    location.reload();
  }
}

//[Optimize API usage]-remove unused API call
export async function checkIsDiaryComplete(){
        const username = window.localStorage.getItem("username")!;
        getDays(username).then((data) => {
            const result: IStatusDay[] = data!.data;
            // eslint-disable-next-line
            let completetedDays = 0;
            result.forEach((day) => {
                if(day.is_complete) {
                    completetedDays += 1;
                }
            });
            // Only check if all 7 days are complete
            if(completetedDays === 7) {
              checkIsAllTimeSlotComplete();
            }
        })
}


export function useTimeslotComplete() {
  return {
    checkIsDiaryComplete
  };
}
